//
//
//
//
//

/**
 * @noteType component
 * @name DirectiveElse
 * @tagName mt-directive-else
 * @desc else容器
 * @type container|directive
 * @directiveName v-else
 * @wrapClassName mint-directive-else
 * @html
 * <mt-directive-else></mt-directive-else>
 */
export default {
    name: 'mt-directive-else',
    methods: {
        handleClick(evt) {
            this.$emit('click', evt);
        }
    },
    props: {}
};




// WEBPACK FOOTER //
// ./packages/directive-else/src/directive-else.vue